import { render, staticRenderFns } from "./PrintingSetsItem.vue?vue&type=template&id=7527b8c2&"
import script from "./PrintingSetsItem.vue?vue&type=script&lang=js&"
export * from "./PrintingSetsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports